import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { richText } from './richText';

export const SanityRichTextSection = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('richTextSection'),
  _key: z.string(),
  pageTitle: z.string().optional().nullable(),
  content: SanityBasicText,
});
export type SanityRichTextSection = z.infer<typeof SanityRichTextSection>;

export const richTextSection = groq`{
  pageTitle,
  content[] ${richText},
}`;
